// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__8JbST","mobileLayout":"AppLayout_mobileLayout__t4h2e","desktopLayout":"AppLayout_desktopLayout__MNQVu"};